export default function PassingIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <circle cx="15" cy="15" r="15" fill="var(--green)" opacity={0.2} />
        <path d="M21 11L12.6 20L9 16.625" stroke="var(--green)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>
  )
}
